import Form from './Form';

export default class HistoryForm extends Form {
    templateId() {
        return '#historyFormTemplate';
    }

    setSection(section) {
        this.section = section;
    }

    params() {
        return {
            accountId: $('#accountId').val(),
            section: this.section
        };
    }

    data() {
        return '/dashboard/profile/ajax/history/get';
    }
}
